<template>
  <div class="unsubscribe">
    <Breadcrumbs :items="[{label:translations['unsubscribe-1']}]"/>
      <p>{{translations['unsubscribe-2']}}</p>
      <rp-button v-if="translations['unsubscribe-button']" @click='activeConfirm = !activeConfirm' class="confirm-btn">{{translations['unsubscribe-button']}}</rp-button>
      <p v-else>No data</p>
    <rp-overlay :active="activeConfirm">
      <rp-confirm
        icon="warning"
        :messageText="translations['unsubscribe-are-you-sure']"
        :btnCancelText="translations['unsubscribe-cancel']"
        :btnConfirmText="translations['unsubscribe-confirm']"
        :cancel="closeModal"
        :confirm="submit"/>
    </rp-overlay>
    <rp-overlay :active="activeAlert">
      <rp-alert
        icon="done"
        :message="translations['unsubscribe-alert-message']"
        :btnContinueMessage="translations['unsubscribe-continue']"
        :onClick="successFunction" />
    </rp-overlay>
  </div>
</template>

<script>
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Confirm from 'raypro_ui/src/components/ui/DeleteConfirm'
import Alert from 'raypro_ui/src/components/ui/Alert'
import Button from 'raypro_ui/src/components/ui/inputs/Button'

import page from '@/mixins/page'
import Breadcrumbs from '@/components/Breadcrumbs'
import store from '@/store/'
import {mapActions} from 'vuex'
import * as authTypes from 'raypro_ui/src/store/modules/auth/types'
import {deletePatientOwn} from 'raypro_ui/src/api/users'
import {getTranslations} from 'raypro_ui/src/api/unsubscribe_translations'

export default {
  components: {
    'rp-overlay': Overlay,
    'rp-confirm': Confirm,
    'rp-button': Button,
    'rp-alert': Alert,
    Breadcrumbs
  },

  data() {
    return {
      activeConfirm: false,
      activeAlert: false,
      translations: {'unsubscribe-1': ''}
    }
  },

  mixins: [page],
  created() {
    this.setToken()
    getTranslations(this.$route.query.locale)
      .then(({data}) => {
        data.map((item) => {
          this.translations[item.title] = item.body
          return item
        })
      })
  },

  methods: {
    ...mapActions([
      'setPatientToken'
    ]),
    setToken() {
      this.setPatientToken(this.$route.query.jwt)
        .then(() => {
        })
        .catch(({response}) => {
          this.errors = response
        })
    },
    removeToken() {
      this.setPatientToken(null)
        .then(() => {
          store.commit(authTypes.TOKEN, null)
        })
        .catch(({response}) => {
          this.errors = response
        })
    },
    successFunction() {
      this.$router.push({name: 'Login'})
    },

    closeModal() {
      this.activeConfirm = false
    },

    submit() {
      deletePatientOwn(this.$route.params)
        .then(() => {
          this.removeToken()
          this.activeConfirm = false
          this.activeAlert = true
        })
        .catch(({response}) => {
          this.errors = response
          this.activeAlert = true
          this.successMessage = this.errors
        })
    }
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'

.confirm-btn
  color: $color-error
  border-color: $color-error
</style>



// WEBPACK FOOTER //
// src/components/pages/Delete/UnsubDelete.vue